export const isValidEmail = (email: string): boolean => {
  const regexp = new RegExp(
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  )
  return regexp.test(email)
}

export const isValidPhone = (phone: string): boolean => {
  // https://stackoverflow.com/a/16699507 this one is much better
  return /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(phone)
}

export const isValidPhoneExtension = (phone: string): boolean => {
  return /^[0-9]{1,6}$/.test(phone)
}

export const updatePhoneValueSearch = (phoneNumber: string): string => {
  phoneNumber = phoneNumber.replace(/-|[{()}\s]/g, '')

  if (phoneNumber.length == 10) {
    phoneNumber = phoneNumber.slice(0, 3) + '-' + phoneNumber.slice(3)
    phoneNumber = phoneNumber.slice(0, 7) + '-' + phoneNumber.slice(7)
  }

  return phoneNumber
}

export const updatePhoneValueForm = (
  phoneNumber: string,
  isDeleteMode: boolean,
): string => {
  const formatted = phoneNumber.replace(/-/g, '')
  if (formatted.length == 3) {
    return formatted + (isDeleteMode ? '' : '-')
  }
  if (formatted.length > 3 && formatted.length < 6) {
    return formatted.slice(0, 3) + '-' + formatted.slice(3)
  }
  if (formatted.length == 6) {
    return (
      formatted.slice(0, 3) +
      '-' +
      formatted.slice(3) +
      (isDeleteMode ? '' : '-')
    )
  }
  if (formatted.length > 6) {
    return (
      formatted.slice(0, 3) +
      '-' +
      formatted.slice(3, 6) +
      '-' +
      formatted.slice(6)
    )
  }

  return phoneNumber
}

export const updateEmailValueSearch = (email: string): string => {
  return email ? email.split(/[,;]/)[0] : email
}

export const updatePhoneNumber = (phoneNumber: string): string => {
  return phoneNumber ? phoneNumber.replace(/[{()}]/g, '') : phoneNumber
}
